import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';

const columns = [{
  Header: 'Date Created',
  id: 'date',
  accessor: row => moment(row.date).format('MMMM Do, YYYY')
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Date of Disconnect',
  accessor: 'failure_detected_when',
}, {
  Header: 'View Credential',
  accessor: 'supplier_id',
  Cell: ({ value }) => <Link to={`/corporate/credentials/${value}`}>View Credential</Link>,
}];

const columnsDownload = [{
  Header: 'Date Created',
  id: 'date',
  accessor: row => moment(row.date).format('MMMM Do, YYYY')
}, {
  Header: 'Supplier',
  accessor: 'supplier_name',
}, {
  Header: 'Date of Disconnect',
  accessor: 'failure_detected_when',
}];


const CredentialUnconnectedTable = ({ credentials, includeExport, buyerName }) => {

  return (
    <Table
      actions={includeExport && (
        <div className='u-paddingTop10'>
          <ColumnExportButton
            filename={`Vetcove_Vendor_Unconnected_${buyerName}.csv`}
            data={credentials}
            columns={columnsDownload}
          >
            Download
          </ColumnExportButton>
        </div>
      )}
      size='small'
      columns={columns}
      data={credentials}
      pageSize={credentials.length || 10}
      showPagination={false}
    />
  );
};

CredentialUnconnectedTable.propTypes = {
  credentials: PropTypes.array.isRequired,
  includeExport: PropTypes.bool,
  buyerName: PropTypes.string.isRequired,
};

export default CredentialUnconnectedTable;
